(function () {
    function initNewsletters() {
        document.querySelectorAll('[data-newsletter]').forEach(initNewsletter);
    }

    function initNewsletter(block) {
        if (block.dataset.newsletterInitialized === '1') return;

        const form = block.querySelector('.blocks__newsletter__form');
        const emailInput = block.querySelector('.blocks__newsletter__email');
        const submitButton = block.querySelector('.blocks__newsletter__submit');
        const status = block.querySelector('[data-newsletter-status]');

        if (!form || !emailInput || !submitButton) return;

        const action = block.dataset.newsletterAction || 'https://embed.email-provider.eu/e/post.php';
        const account = block.dataset.newsletterAccount || '';
        const list = block.dataset.newsletterList || '';
        const emailField = block.dataset.newsletterEmailField || 'email';

        if (!account || !list) {
            setStatus(status, 'Nieuwsbrief is tijdelijk niet beschikbaar.', 'error');
            return;
        }

        block.dataset.newsletterInitialized = '1';

        const startedAt = Date.now();

        form.addEventListener('submit', async (event) => {
            event.preventDefault();

            const email = emailInput.value.trim();
            if (!email) {
                setStatus(status, 'Vul een e-mailadres in.', 'error');
                emailInput.focus();
                return;
            }

            setBusy(form, submitButton, true);
            setStatus(status, '', 'idle');

            const payload = new URLSearchParams();
            payload.set('a', account);
            payload.set('l', list);
            payload.set(emailField, email);

            // Keep the same anti-bot metadata expected by the provider runtime.
            payload.set('email', '');
            payload.set('eprov-elapsed', String(Math.max(1, Date.now() - startedAt)));
            payload.set('eprov-name', String(new Date().getFullYear()));

            try {
                const response = await fetch(action, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                        'Accept': 'application/json'
                    },
                    body: payload.toString(),
                    mode: 'cors'
                });

                if (!response.ok) {
                    throw new Error('Newsletter request failed');
                }

                const data = await response.json();
                const errors = Array.isArray(data && data.errors) ? data.errors : [];

                if (errors.length > 0) {
                    setStatus(status, 'Controleer je e-mailadres en probeer opnieuw.', 'error');
                    emailInput.focus();
                    return;
                }

                form.reset();
                setStatus(status, 'Bedankt! Je bent ingeschreven.', 'success');
            } catch (error) {
                setStatus(status, 'Er ging iets mis. Probeer het opnieuw.', 'error');
            } finally {
                setBusy(form, submitButton, false);
            }
        });
    }

    function setBusy(form, submitButton, isBusy) {
        form.classList.toggle('is-loading', isBusy);
        submitButton.disabled = isBusy;
    }

    function setStatus(statusElement, message, state) {
        if (!statusElement) return;

        statusElement.textContent = message;
        statusElement.dataset.state = state;
    }

    document.addEventListener('DOMContentLoaded', initNewsletters);
    document.addEventListener('blocks:refresh', initNewsletters);
})();
